import { createFileRoute } from '@tanstack/react-router'
import { useStore } from '@tanstack/react-store'
import { useBreadcrumbFromRoute } from '@/hooks/use-breadcrumb-from-route'
import { organizationStore } from '@/stores/organization.store'
import { CloseRateCard } from '@/components/reporting/close-rate-card'
import { LeadsCountCard } from '@/components/reporting/leads-count-card'
import { LeadSourceCard } from '@/components/reporting/lead-source-card'
import { ActivitySummarySection } from '@/components/reporting/activity-summary-section'

export const Route = createFileRoute('/_app/_home/reports')({
  component: ReportsPage,
})

function ReportsPage() {
  const selectedOrganizationId = useStore(organizationStore, (s) => s.selectedOrganizationId)

  useBreadcrumbFromRoute()

  if (!selectedOrganizationId) {
    return null
  }

  return (
    <div className="flex h-full flex-col gap-6 p-6 overflow-y-auto">
      <h1 className="display-heading text-2xl font-semibold tracking-tight">Reports</h1>
      <div className="grid auto-rows-fr gap-4 md:grid-cols-2">
        <CloseRateCard organizationId={selectedOrganizationId} />
        <LeadsCountCard organizationId={selectedOrganizationId} />
      </div>
      <LeadSourceCard organizationId={selectedOrganizationId} />
      <ActivitySummarySection organizationId={selectedOrganizationId} />
    </div>
  )
}
